export default __webpack_public_path__ + "static/media/icon-calculator.21bc9adc.svg";